import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';

import { GOOGLE_REFUSED_NOTE } from '../../../../maps/basemap';
import { AU_STATES, OVERVIEW } from '../map/suburb-map.engine';
import { MapEditsService } from '../workspace/map-edits.service';
import { TEMPLATE_KEYS } from '../template/suburb-template';
import { MapToolsService } from '../workspace/map-tools.service';
import { PageEditorService } from '../workspace/page-editor.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { WORKSPACE_VIEWS, WorkspaceView } from '../workspace/panel';
import { SuburbPlacesService } from '../workspace/suburb-places.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * The Suburbs workspace's tool column (#256): the view switch and "Waiting for review" on top; in Map view the state,
 * the mode, the active region or sub-region and the tool, what the map shows, search, the regions tally and the
 * checks; in List and Readiness views the links to Regions and the other pages; Undo and the status line at the
 * foot. "Page templates" opens the Suburb or Sub-region template's editor (#262).
 */
@Component({
  selector: 'aside[app-suburb-tools]',
  templateUrl: './suburb-tools.component.html',
  styleUrls: ['./suburb-tools.component.scss'],
})
export class SuburbToolsComponent {
  readonly views = WORKSPACE_VIEWS;
  readonly states = [{ code: OVERVIEW, name: '★ All regions (review)' }, ...AU_STATES];
  readonly modes = [
    { label: 'View', value: 'view', key: 'S' },
    { label: 'Assign', value: 'assign', key: 'A' },
    { label: 'Erase', value: 'erase', key: 'E' },
    { label: 'Sub-region', value: 'subregion', key: 'R' },
  ];
  readonly googleRefusedNote = GOOGLE_REFUSED_NOTE;
  readonly templateItems: MenuItem[] = TEMPLATE_KEYS.map((t) => ({
    label: t.label,
    command: () => this.pageEditor.editTemplate(t.key),
  }));

  constructor(
    public state: WorkspaceStateService,
    public places: SuburbPlacesService,
    public nav: PanelNavService,
    public tools: MapToolsService,
    public edits: MapEditsService,
    private pageEditor: PageEditorService
  ) {}

  setView(v: WorkspaceView): void {
    this.state.view = v;
    this.state.redraw();
  }
}
